<template>
        <div class="field has-addons is-inline-block">
                <draggable @end="end" v-if="draggable" v-model="newCategories">
                        <transition-group>
                                <div class="control is-pulled-left" v-for="(category, index ) in categories" :key="category.id + '' + index + category.pivot.color + category.pivot.text_color">
                                        <category-item :selected="true" :category="category" @click="selectCategory"></category-item>
                                </div>
                        </transition-group>
                </draggable>

                <div v-else class="control float-left" v-for="category in categories">
                        <category-item :selected="inCategoryFilters(category) != -1" :category="category" @click="togleCategoryFilter"></category-item>
                </div>

        </div>
</template>
<script>

    import _ from 'lodash'
    import CategoryItem from './CategoryItem'
    export default {
        name: 'CategoryList',
        components: {CategoryItem},
        props: {
            categories: {
                type: Array,
                default: () => []
            },
            // Is  draggable
            draggable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                categoryFilters: [],
                newCategories: [],
            }
        },
        created(){

        },
        mounted(){

        },
        methods: {
            end(data){

                this.$emit('reordered', this.newCategories);
            },
            togleCategoryFilter(category){
                var index = this.inCategoryFilters(category);
                if(index == -1){
                    this.categoryFilters = [];
                    this.categoryFilters.push(category);
                }
                else{
                    this.categoryFilters.splice(index,1);
                }

                this.$emit('click', this.categoryFilters);
            },

            selectCategory(category){
                this.$emit('click', category);
            },

            inCategoryFilters(category){
                return _.indexOf(_.map(this.categoryFilters, 'id'), category.id);
            },
            toggleClick(){

                this.$emit('click', this.category);
            }
        },
        watch: {
            categories: function(val){
                this.newCategories = val;
            }
        }

    }
</script>

<style lang="css" scoped>
        .float-left{
                float:left;
        }

        @media screen and (max-width: 768px){
                .field.has-addons{
                        display: inline-block;
                }

                .field.has-addons .control{
                        width: 100%;
                }
        }

</style>


// WEBPACK FOOTER //
// src/components/category/CategoryList.vue